import clsx from 'clsx';
import { PillProps } from './types';

export function Pill({ text, variant = 'default' }: PillProps) {
  const classes = clsx(
    'inline-flex items-center px-2 py-1 rounded-full text-xs font-medium transition-colors duration-200',
    {
      'bg-gray-100 text-gray-800': variant === 'default',
      'bg-prompt-safecomoutrageous-orange text-white': variant === 'primary',
      'bg-green-100 text-green-800': variant === 'success',
      'bg-yellow-100 text-yellow-800': variant === 'warning',
      'bg-red-100 text-red-800': variant === 'error',
      'bg-blue-100 text-blue-800': variant === 'info',
    },
  );

  return <span className={classes}>{text}</span>;
}
